export default __webpack_public_path__ + "menu.5ecd92a0.svg";